import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UserPanel } from '../user-panel/user-panel';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [
    UserPanel
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {}
